import { BMPrimitives, BMText, useBMTheme } from "@traveloka/district-bloom";
import { FlatList, StyleSheet } from "react-native";
import BMView from "../../../components/View/BMView";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { useRecentlyViewedHotels } from "../../../providers/api/RecentlyViewedHotelsContext";
import HotelCard from "./HotelCard";

export default function RecentlyViewedHotel() {
  const bmTheme = useBMTheme();
  const hotels = useRecentlyViewedHotels();
  const { CorporateHotelRecentlySearch } = useMobileContentResource();

  return (
    <BMView
      style={[
        styles.container,
        { backgroundColor: bmTheme.BMComponents.BMStyleSurfaceBgcolor },
      ]}
    >
      <BMView
        style={[
          styles.badge,
          { backgroundColor: bmTheme.BMComponents.BMStyleSurfaceBgcolorActive },
        ]}
      >
        <BMText ink="BMUiBtngroupInkSelected" variant="uiNormal">
          {CorporateHotelRecentlySearch.recentlyViewedHotelText}
        </BMText>
      </BMView>
      <FlatList
        horizontal
        data={hotels?.recentlySearchedHotels}
        renderItem={({ item }) => <HotelCard {...item} />}
        style={styles.hotelList}
        contentContainerStyle={styles.hotelItem}
        showsHorizontalScrollIndicator={false}
      />
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: BMPrimitives.BMSize.xl,
    paddingBottom: BMPrimitives.BMSize.md,
  },
  badge: {
    alignSelf: "flex-start",
    borderRadius: BMPrimitives.BMRadius.rounded,
    paddingVertical: BMPrimitives.BMSize.sm,
    paddingHorizontal: BMPrimitives.BMSize.lg,
    marginLeft: BMPrimitives.BMSize.md,
  },
  hotelList: {
    marginTop: BMPrimitives.BMSize.xl,
    paddingRight: BMPrimitives.BMSize.md,
  },
  hotelItem: {
    gap: BMPrimitives.BMSize.md,
    paddingLeft: BMPrimitives.BMSize.md,
  },
});
